export default "__VITE_ASSET__DodjhVz7__"